export const LoadingDots = () => (
  <div className="loading-dots-container">
    <span className="loading-dot"></span>
    <span className="loading-dot"></span>
    <span className="loading-dot"></span>
  </div>
);
